import lc from "@/utils/axios";
import { ListPageParams } from "./type";
import { ad } from "@/utils/aesutil";
import { SERVICE_PREFIX } from "@/config/index";

enum API {
  GET_LIST = `${SERVICE_PREFIX}/cloudQuery/getList.action`,
}

// 分页查询
export const listPage = (params: ListPageParams) => {
  return lc.postForm(API.GET_LIST, params);
};

export const queryMyCloudQueryDetail = async (uId: string) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/queryMyCloudQueryDetail.action`;
  let data = { uId };
  return lc.postForm(url, data);
};
// data =>> lon, lat, type, param  新增云查询
export const addCloudQuery = async (data = { type: 0 }): Promise<any> => {
  let url = `${SERVICE_PREFIX}/cloudQuery/addCloudQuery.action`;
  return new Promise((resolve, reject) => {
    lc.postForm(url, data)
      .then((re) => {
        if (re.data && re.data.length > 36) {
          re.data = ad(re.data, "cloudquery");
        }
        resolve(re);
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};

// 获取最新遥感影像
export const getNewImageWithTb = (params: any) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/addCloudQueryByTag.action`;
  return lc.postForm(url, params);
};

//发起i巡查专用
export const addCloudQueryI = async (data = { type: 0 }) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/addCloudQueryI.action`;
  return lc.postForm(url, data);
};

//发起i巡查(bsm)
export const addCloudQueryIByBsm = async (bsm: string) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/addCloudQueryIByBsm.action?bsm=${bsm}`;
  return lc.get(url);
};

//发起云属性
export const addCloudQueryInfo = async (data: any) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/addCloudQueryInfo.action`;
  return lc.postForm(url, data);
};

export const deleteByRequestId = async (requestId: string) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/deleteByRequestId.action`;
  let param = { requestId };
  return lc.postForm(url, param);
};

export const getList = async ({ page, rows, status, name, sort, param, type = 0, analyzeType = 0 }: any) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/getList.action`;
  let data = { page, rows, status, name, sort, param, type, analyzeType };
  return new Promise((resolve, reject) => {
    lc.postForm(url, data)
      .then((re) => {
        if (re.rows && typeof re.rows === "string") {
          re.rows = JSON.parse(ad(re.rows, "cloudquery"));
        }
        resolve(re);
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};

//获取i巡查列表
export const getPatrolTbList = async ({ page, pageSize, filterParam = "", lim, needMedia = false, sortParam = "" }: any) => {
  let url = `land/isearch/getPageList`;
  let data: any = { page, pageSize, filterParam, needMedia, sortParam };
  if (lim) {
    data = { ...data, rests: { "x-image-process": lim } };
  }
  return lc.post(url, data);
};

//获取i巡查历史版本
export const getHistoryTbList = async ({ page, pageSize, filterParam = "", lim }: any) => {
  let url = `land/isearch/getHistoryTbList`;
  let data: any = { page, pageSize, filterParam };
  if (lim) {
    data = { ...data, rests: { "x-image-process": lim } };
  }
  return lc.post(url, data);
};

//获取耕地数据导出历史记录
export const getExportPageList = async ({ page, pageSize, filterParam = "" }: any) => {
  let url = `land/isearch/getExportPageList`;
  let data = { page, pageSize, filterParam };
  return lc.get(url, data);
};

// 获取云查询的地址
export const getDisplayUrl = async (requestId: string, type: number) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/getThirdDetailUrl.action`;
  let data = { type, requestId };
  return lc.get(url, data);
};

// 获取该图斑在数据库保存的查询结果
export const getSimple = async (requestId: string, analyzeType = 0) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/getSimple.action`;
  let data = { requestId, analyzeType };
  return lc.postForm(url, data);
};

// 获取状态（i巡查专用）
export const getSimpleI = async (requestId: string, analyzeType = 0) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/getSimpleI.action`;
  let data = { requestId, analyzeType };
  return lc.postForm(url, data);
};

export const addOne = async (ids: string[], targetUsers: string[], message: string, sm = true) => {
  let url = `${SERVICE_PREFIX}/cloudQueryShare/addOne.action`;
  let data = { ids, targetUsers, message, sm };
  return lc.postForm(url, data);
};
// 获取历史影像的地址
export const findHistoryImage = (requestId: string, title: string) => {
  const url = `${SERVICE_PREFIX}/cloudQuery/getYxxlDetailUrl.action`;
  const params = { requestId, title };
  return lc.get(url, params);
};
// 分享云查询给工作组
export const addOneToWorkGroups = (ids: string[], targetUsers: string[], message: string) => {
  const url = `${SERVICE_PREFIX}/cloudQueryShare/addOneToWorkGroups.action`;
  return lc.get(url, { ids, targetUsers, message });
};
//  获取云查询 所有 tag
export const getAllCloudTags = () => {
  let url = `${SERVICE_PREFIX}/cloudQuery/queryMyCloudItemTag.json`;
  let data = {
    analyzeType: 0,
    displaySet: 14,
  };
  return new Promise((resolve, reject) => {
    lc.get(url, data)
      .then((re) => {
        if (re.data && typeof re.data === "string") {
          re.data = JSON.parse(ad(re.data, "cloudquery"));
        }
        console.log(re);
        resolve(re);
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};

// 通过任务id和图斑id查询 云查询记录的requestId sourceid 是任务的originId
export const getRequestIdByTbTask = (sourceid: string, dataid: string) => {
  const url = `land/cloudQuery/queryHisRecord/${sourceid}/${dataid}`;
  return lc.get(url);
};
//  为 任务对应的图斑 添加云查询记录
export const addCloudRecordByTaskTb = (params = { sourceid: "", dataid: "", requestid: "" }) => {
  const url = "land/cloudQuery/addHisRecord";
  return lc.postForm(url, params);
};

// 获取云查询token
export const getCloudToken = () => {
  const url = "sysconf/cq/token";
  return lc.get(url);
};

// 根据id获取云查询结果
export const getCloudResultByIdI = (id: string) => {
  const url = `${SERVICE_PREFIX}/cloudQuery/getCloudResultByIdI.action?id=${id}`;
  return lc.get(url);
};

// 获取云查询的元数据
export const getCloudMeta = () => {
  const url = `${SERVICE_PREFIX}/cloudQuery/getCloudMeta.action`;
  return new Promise((resolve, reject) => {
    lc.get(url)
      .then((re) => {
        if (re.data && typeof re.data === "string") {
          re.data = JSON.parse(ad(re.data, "cloudquery"));
        }
        console.log(re);
        resolve(re);
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};
// 获取云查询结果 new
export const getCloudResult = (param: any) => {
  const url = `${SERVICE_PREFIX}/cloudQuery/getCloudResultById.action`;
  return lc.get(url, param);
};
// 获取云查询结果(i巡查)
export const getISearchResultById = (id: string, isSave = true) => {
  const url = `${SERVICE_PREFIX}/cloudQuery/getISearchResultById.action`;
  return lc.get(url, { id, isSave });
};

// 逆地理编码(高德)
export const regeo = (location: string, radius: number, extensions: string) => {
  const url = `v3/geocode/regeo?location=${location}&key=7d6637705c7cfbbdffc28389b4fa60e6&radius=${radius}&extensions=${extensions}`;
  return lc.get(url);
};

// 保存i巡查图斑
export const submitPatrolTb = (params: any) => {
  const url = "land/isearch/submitPatrolTb";
  return lc.postForm(url, params);
};

// 同步i巡查图斑到任务(批量)
export const pushPatrolTb = (params: any) => {
  const url = "land/isearch/pushPatrolTb";
  return lc.get(url, params);
};

// 更新并同步i巡查图斑到任务
export const pushOnePatrolTb = (params: any) => {
  const url = "land/isearch/pushOnePatrolTb";
  return lc.postForm(url, params);
};

export const getPatrolTbInfoByCloudQueryId = (cloudqueryid: string) => {
  const url = `land/isearch/getPatrolTbInfoByCloudQueryId/${cloudqueryid}`;
  return lc.get(url);
};

// 批量删除i巡查图斑
export const deletePatrolTb = (params: any) => {
  const url = "land/isearch/deletePatrolTb";
  return lc.get(url, params);
};

// 更新i巡查及任务表属性
export const updateTbProperties = (params: any) => {
  const url = "land/isearch/updateTbProperties";
  return lc.postForm(url, params);
};

export const getCloudQueryById = async (id: string) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/getCloudQueryById.action`;
  let param = { id };
  return lc.postForm(url, param);
};

/**
 * 统计耕地流入流出面积
 * @param params
 * @returns {Promise<*>}
 */
export const statisticGdlrlcArea = (params: any) => {
  const url = "land/isearch/statisticGdlrlcArea";
  return lc.get(url, params);
};

/**
 * 校验是否可以导出
 * @param bizId
 * @param exportType
 * @param regions
 * @returns {Promise<*>}
 */
export const checkExportData = (bizId: string, exportType: string, regions: string) => {
  const url = `land/isearch/checkExportData?bizId=${bizId}&type=${exportType}&regionCode=${regions}`;
  return lc.get(url);
};

export const checkExportData2 = (bizId: string, exportType: string, regions: string) => {
  const url = `land/isearch/checkExportData2?bizId=${bizId}&type=${exportType}&regionCode=${regions}`;
  return lc.get(url);
};

/**
 * 导出台账重试打包
 * @param id
 * @returns {Promise<*>}
 */
export const retryExchange = (id: string) => {
  const url = `land/isearch/retryExchange?id=${id}`;
  return lc.get(url);
};

// 获取。。
export const getCloudSomething = () => {
  const url = `${SERVICE_PREFIX}/cloudQuery/queryMyCloudItem.json?displaySet=8&analyzeType=0`;
  return lc.get(url);
};

export const spatialQuery = (bizId: string, wkt: string, customFilter: string) => {
  const url = `land/taskData/spatial/query?bizId=${bizId}&wkt=${wkt}&customFilter=${customFilter}`;
  return lc.get(url);
};

// 获取云查询记录
export const getCloudQuerysByRequestId = async (requestId: string, analyzeType = 0) => {
  let url = `${SERVICE_PREFIX}/cloudQuery/getCloudQuerysByRequestId.action`;
  let data = { requestId, analyzeType };
  return new Promise((resolve, reject) => {
    lc.postForm(url, data)
      .then((re) => {
        if (re.data && typeof re.data === "string") {
          re.data = JSON.parse(ad(re.data, "cloudquery"));
        }
        resolve(re);
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};

// 验证bsm是否是三调地类标识码
export const checkBsm = (bsm: string) => {
  const url = `extra/common/queryByBsm?year=2023&bsm=${bsm}`;
  return lc.get(url);
};

// 提交云查询纠错
export const addCloudCorrect = (ps: any) => {
  const url = "/cloudqueryapi/correction/item";
  return lc.postForm(url, ps);
};

// 分页查询 纠错的列表
export const getCloudCorrectList = (pas: any) => {
  const url = "/cloudqueryapi/correction/items";
  return lc.get(url, pas);
};
// 获取单个云查询纠错的 详情
export const getCorrectDetail = (id: string) => {
  const url = `/cloudqueryapi/correction/item/${id}`;
  return lc.get(url);
};

// 根据requestId  获取单条云查询的信息  row
export const getCloudRowByRequestId = (requestId: string) => {
  const url = `${SERVICE_PREFIX}/cloudQuery/getOneByRequestId.action`;
  return new Promise((resolve, reject) => {
    lc.get(url, { requestId })
      .then((re) => {
        if (re.data && typeof re.data === "string") {
          re.data = JSON.parse(ad(re.data, "cloudquery"));
        }
        resolve(re);
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};

export const createCloudArchives = async (templateId: string, arr: any[]) => {
  let url = `land/archive/save/${templateId}`;
  return lc.put(url, arr);
};

export const getCloudArchivesRecord = async () => {
  let url = `land/archive/list`;
  return lc.get(url);
};

/**
 * 新版云查询相关 接口
 */

// 获取云查询 列表
export const getNewCloudList = (params: any) => {
  const url = `/gwcloudquery/cloudquery/v1/getPageList`;
  return lc.get(url, params);
};

// 发起云查询
export const createNewCloudQuery = (params: any) => {
  const url = `/gwcloudquery/cloudquery/v1/addCloudQuery`;
  return lc.postForm(url, params);
};

// 查询生成成果报告
export const getCloudReportUrl = (params: any) => {
  const url = `${SERVICE_PREFIX}/export/getCloudReportUrl`;
  return lc.postForm(url, params);
};

// 查询可以导出的报告
export const getCloudReportList = () => {
  const url = `${SERVICE_PREFIX}/export/getCloudReportList`;
  return lc.postForm(url, {});
};
